<template>
  <div class="container">
    <div class="row">
      <!-- Panel izquierdo para mostrar el PDF generado (70%) -->
      <div class="col-left">
        <iframe :src="pdfUrl" v-if="pdfUrl" frameborder="0" class="pdf-viewer"></iframe>
        <div v-else class="no-pdf">Genera un PDF para visualizarlo aquí</div>
      </div>

      <!-- Panel derecho para el formulario de firma (30%) -->
      <div class="col-right">
        <div class="form-container card">
          <div class="form-header">
            <h3>Firma Electrónica</h3>
            <p>Complete los siguientes campos para firmar el PDF</p>
          </div>
          <div class="input-group">
            <label for="keystore">Archivo Keystore:</label>
            <input id="keystore" type="file" @change="onKeystoreChange" placeholder="Archivo Keystore"/>
            <small v-if="keystoreName">{{ keystoreName }}</small>
          </div>
          <div class="input-group">
            <label for="password">Contraseña del Keystore:</label>
            <input id="password" v-model="password" type="password" placeholder="Contraseña del Keystore" />
          </div>
          <div class="input-group">
            <label for="reason">Motivo:</label>
            <input id="reason" v-model="reason" type="text" placeholder="Motivo de la firma" disabled/>
          </div>
          <div class="input-group">
            <label for="location">Ubicación:</label>
            <input id="location" v-model="location" type="text" placeholder="Ubicación de la firma" disabled/>
          </div>
          <button class="sign-button" @click="signPdf">
            <i class="fas fa-signature"></i> Generar y Firmar PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  props: {
    idReporte:   Number,
    idDocumento: Number,
    idPedidoDet: Number,
  },
  data() {
    return {
      pdfUrl: null,
      pdfBlob: null,
      keystore: null,
      keystoreName: '',
      password: '',
      reason: 'Entrega de documentos',
      location: 'Quito'
    };
  },
  mounted() {
    if(this.idPedidoDet == null)
      this.generatePdf();
    else
      this.generatePdfP02();
  },
  methods: {
    onKeystoreChange(e) {
      this.keystore = e.target.files[0];
      this.keystoreName = this.keystore ? this.keystore.name : '';
    },
    async generatePdf() {
      try {
        const response = await api.get(`/reportes/pdf/${this.idReporte}/${this.idDocumento}`, {
          responseType: 'blob'
        });

        this.pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfUrl = URL.createObjectURL(this.pdfBlob);
      } catch (error) {
        console.error('Error al generar el PDF:', error);
        alert('Error al generar el PDF');
      }
    },
    async generatePdfP02() {
      try {
        const response = await api.get(`/reportes/pdf-02/${this.idReporte}/${this.idDocumento}/${this.idPedidoDet}`, {
          responseType: 'blob'
        });

        this.pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        this.pdfUrl = URL.createObjectURL(this.pdfBlob);
      } catch (error) {
        console.error('Error al generar el PDF:', error);
        alert('Error al generar el PDF');
      }
    },
    async signPdf() {
      if (!this.keystore || !this.password || !this.pdfBlob) {
        alert('Todos los campos son necesarios');
        return;
      }

      let formData = new FormData();
      formData.append('file', this.pdfBlob, 'documento.pdf');
      formData.append('keystore', this.keystore);
      formData.append('password', this.password);
      formData.append('reason', this.reason);
      formData.append('location', this.location);
      formData.append('texto', window.sessionStorage.getItem("nombrePersona"));
      formData.append('nombreFirmante', "NOMBRE COMPLETO");
      formData.append('documentoFirmante', "1234567890");

      try {
        const response = await api.post('/signature/sign-pdf', formData, {
          responseType: 'blob' // Recibe el archivo como Blob
        });

        // Crear un Blob a partir del PDF firmado
        const signedPdfBlob = new Blob([response.data], { type: 'application/pdf' });

        // Mostrar el PDF en una nueva pestaña del navegador
        const pdfUrl = URL.createObjectURL(signedPdfBlob);
        window.open(pdfUrl);

        // También puedes crear un enlace de descarga si quieres
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'signed_documento.pdf';
        link.click();

      } catch (error) {
        console.log("Error completo:", error);

        if (error.response) {
          console.log("Estado de error:", error.response.status);
          console.log("Datos de error:", error.response.data);

          let errorMsg = error.response.data || "Ocurrió un error inesperado. Intenta nuevamente.";
          alert("Error: " + errorMsg);
        } else {
          console.error('Error al firmar el PDF:', error);
          alert('Error al firmar el PDF');
        }
      }
    }

  }
};
</script>

<style scoped>
.container {
  display: flex;
  width: 100%;
  height: 100vh;
}

.row {
  display: flex;
  width: 100%;
}

.col-left {
  flex: 7;
  padding: 20px;
  border-right: 1px solid #ddd;
}

.col-right {
  flex: 3;
  padding: 20px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 2px solid #ccc;
}

.no-pdf {
  text-align: center;
  font-size: 18px;
  color: #888;
  padding: 40px;
}

/* Estilo del contenedor del formulario */
.form-container {
  background: linear-gradient(135deg, #76b5c5 0%, #c0e0f8 100%);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
}

.form-container:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.form-header {
  text-align: center;
  margin-bottom: 20px;
}

.form-header h3 {
  color: #fff;
  font-size: 1.5rem;
}

.form-header p {
  color: #fff;
  font-size: 0.9rem;
}

/* Estilo de los campos de entrada */
.input-group {
  margin-bottom: 15px;
}

.input-group label {
  display: block;
  font-weight: bold;
  color: #fff;
  margin-bottom: 5px;
}

.input-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.input-group input:focus {
  border-color: #76b5c5;
  box-shadow: 0 0 8px rgba(118, 181, 197, 0.5);
}

/* Botón de firmar */
.sign-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  width: 100%;
  transition: background-color 0.3s ease;
}

.sign-button i {
  margin-right: 8px;
}

.sign-button:hover {
  background-color: #45a049;
}

.sign-button:active {
  background-color: #388e3c;
}

/* Ajuste responsivo */
@media (max-width: 768px) {
  .col-right {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>

